var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGear = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63098 10.8715L5.93794 11.5618C6.12437 11.9817 6.54067 12.2522 7.00005 12.2522V12.2522C7.45943 12.2522 7.87573 11.9817 8.06216 11.5618L8.36912 10.8715C8.47839 10.6265 8.6622 10.4223 8.89434 10.2879V10.2879C9.12795 10.1531 9.3982 10.0957 9.66641 10.1239L10.4175 10.2038C10.8742 10.2522 11.3166 10.0269 11.5461 9.62902V9.62902C11.7759 9.23141 11.7499 8.73571 11.4796 8.36441L11.0349 7.7534C10.8766 7.53422 10.792 7.2704 10.7933 7.00001V7.00001C10.7932 6.73035 10.8786 6.46762 11.0372 6.24953L11.4819 5.63852C11.7522 5.26722 11.7783 4.77152 11.5484 4.37391V4.37391C11.3189 3.97607 10.8766 3.75078 10.4198 3.79909L9.66875 3.87904C9.40053 3.90721 9.13028 3.84981 8.89668 3.71505V3.71505C8.66407 3.57991 8.48021 3.37461 8.37146 3.12856L8.06216 2.43819C7.87573 2.01834 7.45943 1.74782 7.00005 1.74782V1.74782C6.54067 1.74782 6.12437 2.01834 5.93794 2.43819L5.63098 3.12856C5.52222 3.37461 5.33837 3.57991 5.10576 3.71505V3.71505C4.87215 3.84981 4.6019 3.90721 4.33369 3.87904L3.58029 3.79909C3.12353 3.75078 2.68118 3.97607 2.45166 4.37391V4.37391C2.22183 4.77152 2.24791 5.26722 2.51818 5.63852L2.96287 6.24953C3.12145 6.46762 3.20685 6.73035 3.2068 7.00001V7.00001C3.20685 7.26966 3.12145 7.53239 2.96287 7.75048L2.51818 8.36149C2.24791 8.73279 2.22183 9.22849 2.45166 9.6261V9.6261C2.6814 10.0237 3.12359 10.2489 3.58029 10.2009L4.33136 10.121C4.59957 10.0928 4.86982 10.1502 5.10343 10.285V10.285C5.3369 10.4197 5.52161 10.6251 5.63098 10.8715V10.8715Z",
    stroke: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.00005,
    cy: 7.00002,
    r: 1.54473,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGear);
export default ForwardRef;